import { DrawerPanel } from '@dmc/ui';
import useLoadModelData from '@casops/components/layout/model-form/useLoadModelData';
import { GEOFENCE_KEY, HOME_OVERVIEW_GEOFENCES } from '@casops/navigation';
import GeofenceForm from '@casops/side-panels/manage-geofence/components/form/GeofenceForm';
import { useLoadGeofenceDataDependencies } from '@casops/side-panels/manage-geofence/useLoadGeofenceDataDependencies';
import { useGetGeofenceQuery } from '@casops/store/apis/geofencesApi';
import { VdsButton } from '@volt/volt-extended-components-react';
import { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { createSearchParams, To, useParams } from 'react-router-dom';
import EditGeofenceHeader from './components/header/EditGeofenceHeader';
import { ModelName } from '@casops/store/api';
import DiscardFormDialog from '@casops/dialogs/discard-form-dialog/DiscardFormDialog';
import { useDiscardFormDialog } from '@casops/dialogs/discard-form-dialog/useDiscardFormDialog';

export const EditGeofence = (): ReactElement => {
  const { t } = useTranslation();
  const { geofenceId } = useParams();

  const { isLoaded: isItemLoaded, item } = useLoadModelData({
    useModelQueryHook: useGetGeofenceQuery,
    editMode: true,
    id: geofenceId,
  });

  const { isLoaded, renderKey } = useLoadGeofenceDataDependencies({ isItemLoaded, item });

  const navigateTo = useMemo<To>(() => {
    return {
      pathname: HOME_OVERVIEW_GEOFENCES,
      search: geofenceId ? createSearchParams({ [GEOFENCE_KEY]: geofenceId }).toString() : '',
    };
  }, [geofenceId]);

  const { dialogRef, onCancel, onDiscard, leaveView, setIsFormDirty } = useDiscardFormDialog({
    navigateTo,
  });

  return (
    <>
      <DrawerPanel
        isLoaded={isLoaded}
        header={<EditGeofenceHeader item={item} />}
        fillSidePanel={false}
        footer={
          <VdsButton variant="ghost" size="medium" disabled={false} isFullWidth onClick={onCancel}>
            {t('Cancel')}
          </VdsButton>
        }
      >
        <GeofenceForm
          key={renderKey}
          item={item}
          editMode={true}
          customSuccessCallback={leaveView}
          setIsFormDirty={setIsFormDirty}
        />
      </DrawerPanel>
      <DiscardFormDialog
        elementRef={dialogRef}
        modelName={ModelName.Geofence}
        onDiscard={onDiscard}
      />
    </>
  );
};

export default EditGeofence;
